import React, { useState } from 'react';
import classNames from 'classnames';
import { client } from '@trello/config';
import { Icon, IconColor, IconName } from 'app/common/components/controls';

import styles from './CopyHeadURL.less';

const CALLBACK_RESET_DELAY = 2000;
const headURL = `${window.location.origin}/support/try?name=${client.head}&version=${client.version}&time=999`;

const copyToClipboard = (
  successCallback: () => void,
  errorCallback: () => void,
) => () => {
  const textArea = document.createElement('textarea');

  textArea.value = headURL;
  textArea.style.opacity = '0';
  textArea.style.position = 'fixed';
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    document.execCommand('copy');
    successCallback();
  } catch (err) {
    console.error('Unable to copy HEAD URL', err);
    errorCallback();
  }

  document.body.removeChild(textArea);
};

export const CopyHeadURL: React.FunctionComponent = () => {
  const [copyState, setCopyState] = useState<'error' | 'success' | null>(null);
  const copyStateCallback = (state: 'error' | 'success') => () => {
    setCopyState(state);
    setTimeout(() => setCopyState(null), CALLBACK_RESET_DELAY);
  };

  return (
    <>
      <strong className={styles.headURLTitle}>Head URL</strong>
      <div className={styles.headURLContainer}>
        <pre className={styles.headURL}>{headURL}</pre>
        <button
          onClick={copyToClipboard(
            copyStateCallback('success'),
            copyStateCallback('error'),
          )}
          disabled={copyState !== null}
          className={classNames(
            styles.copy,
            copyState === 'success' && styles.copySuccess,
            copyState === 'error' && styles.copyError,
          )}
        >
          <Icon
            large
            className={styles.copyIcon}
            color={
              copyState === 'success'
                ? IconColor.Light
                : copyState === 'error'
                ? IconColor.Light
                : IconColor.Dark
            }
            name={
              copyState === 'success'
                ? IconName.CheckboxChecked
                : copyState === 'error'
                ? IconName.Close
                : IconName.Copy
            }
          />
        </button>
      </div>
    </>
  );
};
